import moment from 'moment';

export const formatDate = (date: Date | string) => {
    return moment(date).format('YYYY-MM-HH:mm');
};

export const formatDay = (date: Date | string) => {
    if (!date) return '/';
    return moment(date).format('dddd DD MMMM YYYY');
};

export const formatHour = (date: Date | string) => {
    return moment(date).format('HH[h]mm');
};
